export const PORTALTHIRD_BASE_URL = "delaportaal";

export const APPLICATION_TYPE_DUP = "DUP";
export const APPLICATION_TYPE_DLP = "DLP";

export const INSIS_SYSTEM_ID = "INSIS";

export const APPLICATION_STATUS_DRAFT = "Draft";
export const APPLICATION_STATUS_SUBMITTED = "Submitted";
